module.exports = __webpack_public_path__ + "static/media/290160.99c904ad.png";